import { Directive, inject, Input, type OnInit, signal, TemplateRef, ViewContainerRef } from '@angular/core';
import { type FeatureToggleKeys, FeatureToggleService } from './feature-toggle.service';

@Directive({ selector: '[featureToggle]' })
export class FeatureToggleDirective implements OnInit {
  templateRef = inject(TemplateRef);
  viewContainer = inject(ViewContainerRef);
  featureToggleService = inject(FeatureToggleService);
  hasView = signal(false);

  private _shouldShow = false;
  private _featureToggle: FeatureToggleKeys;

  @Input() set featureToggle(featureToggle: FeatureToggleKeys) {
    this._featureToggle = featureToggle;
  }

  @Input({ required: true }) set featureToggleShow(shouldShow: boolean) {
    this._shouldShow = shouldShow;
  }

  ngOnInit() {
    let showFeature = this.featureToggleService.getFeature(this._featureToggle);
    // Some feature toggles are "disable" or "hide" toggles.
    // Meaning if the featureToggle is set to true, the feature should be hidden.
    showFeature = this._shouldShow ? showFeature : !showFeature;

    if (showFeature && !this.hasView()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView.set(true);
    } else {
      this.viewContainer.clear();
      this.hasView.set(false);
    }
  }
}
